import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";

const FormSingleButtonGroup = ({
  options = [],
  onChange,
  selectedValue,
  label,
  name,
  disabled,
}) => {
  const className = disabled ? "disabled" : "";

  return (
    <div className="single-button">
      <div
        className={`form-control form-button-group ${className}`}
        style={{ backgroundColor: "white" }}
      >
        <ButtonGroup aria-label={label} name={name}>
          {options.map(({ label, value }, index) => {
            const selectedClass = selectedValue === value ? "selected" : "";
            let buttonProps = {};
            if (!disabled) {
              buttonProps = { onClick: () => onChange(value) };
            }
            return (
              <Button
                key={index}
                type="button"
                className={selectedClass}
                {...buttonProps}
                disabled={disabled}
                style={{ backgroundColor: disabled ? "#eeeeee" : "white" }}
                data-attr={value}
              >
                {label}
              </Button>
            );
          })}
        </ButtonGroup>
      </div>
    </div>
  );
};

export default FormSingleButtonGroup;
